import { Action, DispatchEvent, EventUpdateType } from "@/App/components/Dispatch/DispatchEvents/dispatchEvent";

type EventTexts = {
  [key in EventUpdateType]: {
    buttonLabel: string;
    warning: string;
  };
};

const eventText: Record<DispatchEvent, EventTexts> = {
  [DispatchEvent.cancel]: {
    [EventUpdateType.add]: {
      buttonLabel: "Cancel Case",
      warning: "Do you want to cancel this case?",
    },
    [EventUpdateType.remove]: {
      buttonLabel: "Reinstate Case",
      warning: "Do you want to reinstate this case?",
    },
  },
  [DispatchEvent.close]: {
    [EventUpdateType.add]: {
      buttonLabel: "Close Case",
      warning: "Do you want to close this case?",
    },
    [EventUpdateType.remove]: {
      buttonLabel: "Reopen Case",
      warning: "Do you want to reopen this case?",
    },
  },
};

function shouldIncludeType(event: DispatchEvent | Action, type?: EventUpdateType): boolean {
  return !(event === DispatchEvent.close && type === EventUpdateType.remove);
}

const createEventUpdateRequestBody = (event: DispatchEvent | Action, type?: EventUpdateType) => {
  let eventValue: DispatchEvent | Action = event;

  if (event === DispatchEvent.close && type === EventUpdateType.remove) {
    eventValue = Action.reopen;
  }

  return {
    event: eventValue,
    ...(shouldIncludeType(event, type) ? { type } : {}),
  };
};

export { eventText, createEventUpdateRequestBody };
